import React from 'react'
import { ModalWrapper } from '../../../../../../components'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { useSelector } from 'react-redux'
import { formatDate } from '../../../../../../components/Table/TableCells/TableCell'

export const ExpenseDetail = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  return (
    <ModalWrapper open={open} handleClose={handleClose} title={'Expense Detail'} width={'500px'}>
      <div className="add-employee">
        <InfoField label={'Title'} value={data?.expense_title} width={'100%'} />
        <InfoField label={'School'} value={data?.school_name} width={'100%'} />
        <InfoField label={'Category'} value={data?.expense_category} width={'100%'} />
        <InfoField label={'Employee'} value={data?.employee_name} width={'100%'} />
        <InfoField label={'Date'} value={formatDate(data?.expense_date)} width={'100%'} />
        <InfoField label={'Amount'} value={data?.expense_amount} width={'100%'} />
        <InfoField label={'Description'} value={data?.expense_description} width={'100%'} />
        {/* <InfoField label={'Paid To'} value={data?.expense_paid_to} width={'100%'} /> */}
      </div>
    </ModalWrapper>
  )
}
